import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.3144 5.50765L14.933 3.88909C15.1281 3.69393 15.1281 3.37714 14.933 3.18198L12.1045 0.353553C11.9094 0.158392 11.5926 0.158392 11.3974 0.353553L9.77886 1.97212C9.5837 2.16728 9.5837 2.48406 9.77886 2.67923L12.6073 5.50765C12.8024 5.70281 13.1192 5.70281 13.3144 5.50765Z",
		fill: "#939EA7"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.44357 3.30765L1.76777 9.98345C1.58039 10.1708 1.47432 10.4254 1.47503 10.6906L1.47503 12.8119C1.47503 13.3648 1.92263 13.8124 2.47488 13.8117L4.5962 13.8117C4.86207 13.8117 5.11592 13.7064 5.30331 13.519L11.9791 6.84319C12.1743 6.64803 12.1743 6.33124 11.9791 6.13608L9.15067 3.30765C8.95551 3.11249 8.63873 3.11249 8.44357 3.30765Z",
		fill: "#939EA7"
	})]
});
export default SvgEdit;
